'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pubsubConnectionFailed = undefined;

var _reselect = require('reselect');

var _statusComparators = require('conversations-internal-schema/async-data/operators/statusComparators');

var _getAsyncPubSubClient = require('./getAsyncPubSubClient');

var pubsubConnectionFailed = exports.pubsubConnectionFailed = (0, _reselect.createSelector)([_getAsyncPubSubClient.getAsyncPubSubClient], _statusComparators.isFailed);


//////////////////
// WEBPACK FOOTER
// ./js/pubsub/selectors/pubsubConnectionFailed.js
// module id = 631
// module chunks = 2 3